var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOdnoklassnikiCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F7931E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04344 3C6.56945 3 5.37457 4.16021 5.37457 5.59136C5.37457 7.02254 6.56945 8.18282 8.04344 8.18282C9.51744 8.18282 10.7123 7.02254 10.7123 5.59136C10.7123 4.16021 9.51744 3 8.04344 3ZM8.04344 6.66264C7.43415 6.66264 6.94019 6.18299 6.94019 5.59139C6.94019 4.99979 7.43415 4.52018 8.04344 4.52018C8.65274 4.52018 9.1467 4.99979 9.1467 5.59139C9.1467 6.18299 8.65274 6.66264 8.04344 6.66264Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98568 10.2448C10.0541 10.0334 10.6944 9.54214 10.7283 9.51577C11.0409 9.27232 11.0912 8.82887 10.8404 8.52526C10.5897 8.22169 10.133 8.17292 9.82032 8.41634C9.81371 8.42153 9.13081 8.93018 8.0072 8.93092C6.88363 8.93018 6.18629 8.42153 6.17968 8.41634C5.86696 8.17292 5.41028 8.22169 5.15958 8.52526C4.90884 8.82887 4.95906 9.27232 5.27171 9.51577C5.30605 9.54251 5.97275 10.0466 7.07116 10.253L5.54033 11.8063C5.26213 12.0865 5.27049 12.5325 5.559 12.8026C5.69982 12.9345 5.88132 13 6.06266 13C6.25279 13 6.44272 12.9279 6.58511 12.7845L8.00724 11.3135L9.57301 12.794C9.85671 13.069 10.3161 13.0686 10.5993 12.7932C10.8824 12.5178 10.8821 12.0717 10.5985 11.7968L8.98568 10.2448Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0072 8.93092C8.0054 8.93092 8.00896 8.93092 8.0072 8.93096C8.00544 8.93092 8.00899 8.93092 8.0072 8.93092Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdnoklassnikiCircle);
export default __webpack_public_path__ + "static/media/odnoklassnikiCircle.dac644d7c9e8b42c178301ba7a2eaf52.svg";
export { ForwardRef as ReactComponent };